import React from 'react';
import {Stack, useTheme} from '@mui/material';
import {useSearchParams} from 'react-router-dom';

import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {HighlightedText} from 'presentation/components';
import {getSpecialtyBySearch} from 'presentation/utils/GetSpecialtyBySearch';
import {SelectCardList, StyledIcon} from './styles';
import {CardListProps} from './types';
import {OnDemandExamsChip} from './components/OnDemandExamsChip';

export function ExamCard({
	text,
	handleClick,
	dataTagId,
	isOnDemandExam,
	...cardProps
}: CardListProps) {
	const [searchParams] = useSearchParams();
	const {colors} = useTheme();
	const specialtyBySearch = getSpecialtyBySearch({
		text: searchParams.get('q') || '',
	});

	const query = specialtyBySearch;

	return (
		<SelectCardList
			{...cardProps}
			elevation={0}
			data-tag-id={dataTagId}
			sx={{cursor: 'pointer'}}>
			<Stack p={2} gap={1} direction="row" alignItems="center" onClick={handleClick}>
				<Stack gap={0.5}>
					{isOnDemandExam && <OnDemandExamsChip />}
					<HighlightedText
						text={text}
						highlight={query}
						dataTagId={AppointmentBookingEnum.SELECIONOU_ESPECIALIDADE_TEXT}
					/>
				</Stack>
				<Stack flex={1} justifyContent={'center'} height={'100%'}>
					<StyledIcon name="arrow-right" size={24} color={colors.brand.primary.blue} />
				</Stack>
			</Stack>
		</SelectCardList>
	);
}
